import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Firebase, { FirebaseContext } from './config';
import { initialState } from './session/initialState';
import { StateProvider } from './session/store';
import { mainReducer } from './session/reducers'
import './index.css'
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


const theme = createMuiTheme({
  typography: {
   "fontFamily": `"Montserrat"`,
   "fontSize": 14,
   "fontWeightLight": 300,
   "fontWeightRegular": 400,
   "fontWeightMedium": 500
  },
  palette: {
    primary: {
      main: '#019BE2',
    },
    secondary: {
      main: '#7B8C8C',
    },
  },
});

ReactDOM.render(
<FirebaseContext.Provider value={new Firebase()}>
  <ThemeProvider theme={theme}>
    <StateProvider initialState={initialState} reducer={mainReducer}>
      <App/>
    </StateProvider>
  </ThemeProvider>
</FirebaseContext.Provider>
,document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
